import React from 'react';
import { ArrowRightIcon, LightbulbIcon } from 'lucide-react';
import type { Lead, ScriptLine } from '../types/leadScript';
import { renderScriptText } from '../utils/scriptText';
interface ScriptLineViewProps {
  line: ScriptLine;
  lead: Lead;
}
export function ScriptLineView({
  line,
  lead
}: ScriptLineViewProps) {
  const text = renderScriptText(line.text, lead);
  switch (line.kind) {
    case 'lo':
      return <p className="text-[15px] font-medium leading-7 text-ink" data-id="element-35" data-mp="16jqdlmukryb8">
          <span className="mr-2 align-[1px] text-[11px] font-bold tracking-wide text-accent" data-id="element-36" data-mp="11jayoqunair5">LO</span>
          {text}
        </p>;
    case 'borrower':
      return <div className="ml-6 rounded-xl rounded-tl-sm bg-canvas px-3.5 py-2.5" data-id="element-37" data-mp="sj5s2ix9zoe1">
          <p className="text-[11px] font-semibold text-muted" data-id="element-38" data-mp="sl8szxzyv1xj">Borrower</p>
          <p className="mt-0.5 text-sm leading-relaxed text-ink" data-id="element-39" data-mp="2qy8q5kmqsng3">{text}</p>
        </div>;
    case 'branch':
      return <div className="border-l-[3px] border-accent pl-3.5" data-id="element-40" data-mp="2mvcfcg3g1vmp">
          <p className="text-[13px] font-bold text-accent-ink" data-id="element-41" data-mp="muwxt0h75iod">{line.label}</p>
          <p className="mt-1 text-[15px] font-medium leading-7 text-ink" data-id="element-42" data-mp="rv1bkiqpzzaw">{text}</p>
        </div>;
    case 'cue':
      return <p className="flex items-start gap-2 rounded-lg bg-ink px-3.5 py-2.5 text-[13px] font-semibold leading-snug text-white" data-id="element-43" data-mp="dwt9xxiqo9te">
          <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#F29B6B]" aria-hidden="true" data-id="element-44" data-mp="15m6470vo7rbq" />
          <span data-id="element-45" data-mp="1al9b6qv7o7mc">{text}</span>
        </p>;
    case 'note':
      return <p className="flex items-start gap-2 rounded-lg bg-accent-soft px-3.5 py-2.5 text-[13px] leading-relaxed text-accent-ink" data-id="element-46" data-mp="1andbyzxtcqie">
          <LightbulbIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-47" data-mp="10v7kdrbh4b3q" />
          <span data-id="element-48" data-mp="1ol1zkfj9mbr5">{text}</span>
        </p>;
  }
}